var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{attrs:{"loading":_setup.investment_activity.loading,"empty":_setup.isEmpty}},[_c(_setup.BreifCard,{attrs:{"listData":_setup.activityList,"isShowType":_setup.isNotEn,"styleConfig":_vm.styleConfig},on:{"goToDetail":_setup.handleClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }